export default import.meta.ROLLUP_FILE_URL_eIJA1ilgVd6BWdWINJZi0Q